export default __webpack_public_path__ + "assets/icon-light.cfbe082bf429011536a7933e7133857c.png";